<!-- RESULTADO (esqueleto: completar a mano) -->


<!-- DATOS (mismo criterio que el bloque DATA en detalle POL) -->
<tec-collapse
    [icon]="'icon-capture-popup'"
    [title]="'OPERATIONS.DETAIL.TABS.DETAILS.DATA' | translate"
    [expanded]="expandedCollapseSection === 'data'"
    (clickEvent)="toggleCollapse('data', $event)"
>
    <app-operation-ocr-details-data [data]="ocrData ?? undefined" />
</tec-collapse>

<!-- MEDIA (mismo criterio que detalle POL: galería y descarga) -->
<tec-collapse
    [icon]="'icon-image'"
    [title]="'OPERATIONS.DETAIL.TABS.DETAILS.MEDIA' | translate"
    [expanded]="expandedCollapseSection === 'media'"
    (clickEvent)="toggleCollapse('media', $event)"
>
    @if (hasOcrMedia) {
        <app-operation-detail-tabs-details-media [detail]="detail" />
    } @else {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    }
</tec-collapse>

<!-- OPERACIÓN (mismos campos que el tile de operación OCR en detalle de proceso) -->
<tec-collapse
    [icon]="'icon-pending-check'"
    [title]="'OPERATIONS.DETAIL.TABS.DETAILS.OPERATION' | translate"
    [expanded]="expandedCollapseSection === 'operation'"
    (clickEvent)="toggleCollapse('operation', $event)"
>
    @if (ocrData) {
        <app-operation-detail-operation-meta
            [operationUuid]="ocrData.uuid"
            [processUuid]="detail?.process_uuid"
            [startAt]="ocrData.start_at"
            [endAt]="ocrData.end_at"
            [totalTime]="ocrData.total_time"
            triesStyle="tag"
            [triesLabel]="ocrTriesLabel()"
            [captureMethodLabel]="ocrCaptureMethodLabel()"
            [showMiDni]="showMiDni"
        />
    }
</tec-collapse>
